/*
 * Drives the GSAP motion engine for the whole app. Mounted once in _app, it
 * (re)initialises every animation each time the route changes, which is what
 * recreates the original per-page entry "transition" on client-side navigation.
 */
import type { FC, ReactNode } from 'react'

import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { initMotion } from '@/animations'

interface MotionProviderProps {
    children: ReactNode
}

export const MotionProvider: FC<MotionProviderProps> = ({ children }): ReactNode => {
    const { asPath } = useRouter()

    useEffect(() => {
        let cleanup: () => void = () => {}

        // Wait one frame so the new page's DOM is committed and laid out
        // before we measure scroll positions and start animations.
        const raf = requestAnimationFrame(() => {
            cleanup = initMotion(document.body)
        })

        return () => {
            cancelAnimationFrame(raf)
            cleanup()
        }
    }, [asPath])

    return <>{children}</>
}
